import { render, staticRenderFns } from "./Heard.vue?vue&type=template&id=08bd4078&scoped=true"
import script from "./Heard.vue?vue&type=script&lang=js"
export * from "./Heard.vue?vue&type=script&lang=js"
import style0 from "./Heard.vue?vue&type=style&index=0&id=08bd4078&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_7d97cc52897b1b5edd1ee8818c6a75fc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bd4078",
  null
  
)

export default component.exports